<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-08-14 14:58:08
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-15 16:44:45
 * @FilePath: \toolmap\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <div class="headerBox">
      <div class="logoBox"></div>
      <div class="navListBox">
        <div class="navListBoxItem" :class="[activeName=='/'?'active2':'']" @click="getoPage('/')">台风预报点</div>
        <div class="navListBoxItem" :class="[activeName=='/wind'?'active2':'']" @click="getoPage('/wind')">风场导入预览</div>
      </div>
    </div>
    <router-view class="viewBody" />
  </div>
</template>
<script>
export default {
  data(){
    return {
      activeName:"/",
    }
  },
   created(){
    console.log(this.$route.fullPath);
    this.activeName = this.$route.fullPath
  },
  methods:{
    getoPage(data){
      this.$router.push(data)
      this.activeName = data
     
    }
  }
}
</script>
<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
#app {
  height: 100vh;
  width: 100vw;
  /* background-color: aqua; */
}
.headerBox {
  height: 60px;
  width: 100%;
  background-color: #000000;
  display: flex;
}
.logoBox {
  height: 100%;
  width: 50%;
}
.navListBox {
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: flex-end;
  /* background-color: aqua; */
}
.navListBoxItem {
  height: 100%;
  width: 20%;
  /* background-color: beige; */
  line-height: 60px;
  text-align: center;
  color: white;
}
.navListBoxItem.active2 {
  height: 100%;
  width: 20%;
  /* background-color: beige; */
  line-height: 60px;
  text-align: center;
  color: #42a0fd;
}
/* .viewBody {
  width: 100%;
  height: calc(100vh - 80px);
} */
</style>
